import { get, isUndefined } from 'lodash';
import React from 'react';
import { FBLabelFontSize, FBLabelProps } from '..';

export const withFBLabel = <T extends FBLabelProps>(
  Component: React.FunctionComponent<T>,
) => {
  return (props: T) => {
    const { fontSize = 'md', ...rest } = props;

    const resolvedFontSize = !isUndefined(get(FBLabelFontSize, fontSize))
      ? `${get(FBLabelFontSize, fontSize)}.fontSize`
      : fontSize;

    return <Component {...(rest as T)} fontSize={resolvedFontSize} />;
  };
};
